
import './EpisodeSelector.scss';
export default function EpisodeSelector(props: any) {

    return (
        <div className="episodeSelector " data-uia="episode-selector">{props.children}</div>
    );
}